/* @flow */

import { transparentize } from 'polished';

import { listReset } from 'src/shared/app/base/style/token/helper';
import { white } from '@e180/ui/lib/token/palette';

export default {
  root: {
    ...listReset,

    display: 'flex',
    flexWrap: 'wrap',
    justifyContent: 'center',

    color: transparentize(0.33, white),
    fontSize: 13,
  },
  item: {
    '&:not(:last-child):after': {
      content: "'\u2022'",

      display: 'inline-block',

      margin: '0 0.5em',
    },
  },
};
